import axios from 'axios'
import Cookies from 'js-cookie'
function isTokenInvalidError(error) {
  const { message } = error.response.data
  return message === 'jwt expired'
}
function responseErrorHandler(error) {
  if (isTokenInvalidError(error)) {
  } else if (error.response.status >= 500) {
    alert('伺服器發生錯誤，請聯絡管理人員')
  }
  return Promise.reject(error.response)
}

function responseSuccessHandler(response) {
  return response.data
}

const API = axios.create({
  baseURL: `https://us-central1-backstage-web-e5597.cloudfunctions.net/recordBehavior`,
  timeout: 1000 * 6,
})

API.interceptors.response.use(responseSuccessHandler, responseErrorHandler)

var RecordBill = (function () {
  function recordBill() {}
  recordBill.prototype.postRecord = function (para) {
    return API.post(``, para)
  }
  recordBill.prototype.getRecord = async function (type, id) {
    return await API.get(
      `?type=${decodeURI(type)}&id=${id}&code=${Cookies.get('GladTeamCode')}`,
    )
      .then((res) => {
        return {
          success: true,
          result: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  return recordBill
})()
export default RecordBill



// WEBPACK FOOTER //
// ./src/assets/js/libs/FirebaseAPI/RecordBill.js